import { useEffect } from 'react';

const isMultilineEditorTarget = (target) => {
  if (!target) return false;
  if (target.tagName === 'TEXTAREA') return true;
  if (target.isContentEditable) return true;

  return Boolean(target.closest?.('[contenteditable="true"]'));
};

const useKeyPress = (callback, keys = [], enabled = true) => {
  useEffect(() => {
    if (!enabled) return undefined;
    if (typeof callback !== 'function') return undefined;
    if (!Array.isArray(keys) || keys.length === 0) return undefined;

    const onKeyPress = (event) => {
      const wasAnyKeyPressed = keys.some((key) => event.key === key);
      if (!wasAnyKeyPressed) return;
      if (event.key === 'Enter' && isMultilineEditorTarget(event.target)) return;

      event.preventDefault();
      callback(event);
    };

    document.addEventListener('keydown', onKeyPress);
    return () => {
      document.removeEventListener('keydown', onKeyPress);
    };
  }, [callback, enabled, keys]);
};

export default useKeyPress;
